<template style="">
  <div class="Workload_analysis">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <!-- <el-form-item label="综合查询">
        <el-input v-model="formInline.Name" placeholder="综合查询"></el-input>
      </el-form-item> -->
      <el-form-item label="统计时间">
        <el-date-picker value-format="yyyy-MM-dd" v-model="formInline.time" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
      </el-form-item>
    </el-form>
    <div style="width: 100%;height: calc(100% - 115px);background-color: #fff;margin-top: 14px;">
      <el-button type="primary" @click="Income_allocation()" style="margin-top: 14px;margin-left: 1%;">新增收益配置</el-button>
      <el-table :data="tableData" style="width: 98%;margin-left: 1%;padding-top: 14px;">
        <el-table-column prop="ArticleRevenue" label="文章收益" ></el-table-column>
        <el-table-column prop="VideoRevenue" label="视频收益" ></el-table-column>
        <el-table-column prop="MusicRevenue" label="音频收益"></el-table-column>
        <!-- <el-table-column prop="PictureRevenue" label="图片收益"></el-table-column> -->
        <el-table-column prop="EditArticleRevenue" label="编辑文章收益"></el-table-column>
        <el-table-column prop="EffectTime" label="生效时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span v-if="scope.row.Flag == 1" style="margin-left: 10px;cursor: pointer;color: rgb(31, 52, 245);" @click="re_look(scope.row)">修改</span>
            <span v-else style="margin-left: 10px;cursor: pointer;color: rgb(177, 177, 177);">修改</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination style="margin-top: 20px;text-align: right" @current-change="handleCurrentChange" :current-page.sync="formInline.PageIndex" :page-size="formInline.PageSize" layout="total, prev, pager, next" :total="UndoCount"></el-pagination>
      
    </div>
    <el-dialog title="收益配置" :visible.sync="dialogVisible" width="500px" :before-close="handleClose">
      <el-form label-width="80px">
        <el-form-item label="文章收益">
          <el-input v-model="ArticleRevenue"></el-input>
        </el-form-item>
        <el-form-item label="视频收益">
          <el-input v-model="VideoRevenue"></el-input>
        </el-form-item>
        <el-form-item label="音频收益">
          <el-input v-model="MusicRevenue"></el-input>
        </el-form-item>
        <!-- <el-form-item label="图片收益">
          <el-input v-model="PictureRevenue"></el-input>
        </el-form-item> -->
        <el-form-item label="编辑文章收益">
          <el-input v-model="EditArticleRevenue"></el-input>
        </el-form-item>
        <el-form-item label="生效时间">
          <el-date-picker v-model="EffectTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
        </el-form-item>
      </el-form>
      <el-button type="primary" :loading="iscontinuous" @click="add()">{{ tie }}</el-button>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      iscontinuous:false,
      tie:'添加',
      formInline: {
        Name: '',
        time: [],
        PageSize: 10,
        PageIndex: 1,
      },
      tableData: [],
      UndoCount: 0,
      dialogVisible: false,
      ArticleRevenue: "0",	//文章收益
      VideoRevenue: "0",		//视频收益
      MusicRevenue: "0",		//音频收益
      PictureRevenue: "0",		//图片收益
      EditArticleRevenue: "0",		//编辑文章收益
      EffectTime: "",	//生效时间
      Key: "",	//生效时间
    }
  },
  mounted() {
    this.loading();
  },
  methods: {
    add() {
      this.iscontinuous = true
      if (this.tie == '添加') {
        this.$Http_Post('management/revenueAllocation', {
          ArticleRevenue: this.ArticleRevenue,
          VideoRevenue: this.VideoRevenue,
          MusicRevenue: this.MusicRevenue,
          PictureRevenue: this.PictureRevenue,
          EditArticleRevenue: this.EditArticleRevenue,
          EffectTime: this.EffectTime,
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.iscontinuous = false
            this.Global.request_successful(res.Message);
            this.dialogVisible = false;
            this.ArticleRevenue = ''	//文章收益
            this.VideoRevenue = ''		//视频收益
            this.MusicRevenue = ''		//音频收益
            this.PictureRevenue = ''		//图片收益
            this.EditArticleRevenue = ''		//编辑文章收益
            this.EffectTime = ''	//生效时间
            this.Key = ''
            this.loading();
          } else {
            this.iscontinuous = false
            this.Global.request_failure(res.Message);
          }
        })
      } else {
        this.$Http_Post('management/materialIncomeUpdate', {
          ArticleRevenue: this.ArticleRevenue,
          VideoRevenue: this.VideoRevenue,
          MusicRevenue: this.MusicRevenue,
          PictureRevenue: this.PictureRevenue,
          EditArticleRevenue: this.EditArticleRevenue,
          EffectTime: this.EffectTime,
          RevenueKey:this.Key
        }).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.iscontinuous = false
            this.Global.request_successful(res.Message);
            this.dialogVisible = false
            this.ArticleRevenue = ''	//文章收益
            this.VideoRevenue = ''		//视频收益
            this.MusicRevenue = ''		//音频收益
            this.PictureRevenue = ''		//图片收益
            this.EditArticleRevenue = ''		//编辑文章收益
            this.EffectTime = ''	//生效时间
            this.Key = ''
            this.loading();
          } else {
            this.iscontinuous = false
            this.Global.request_failure(res.Message);
          }
        })
      }

      

    },
    re_look(row) {
      this.dialogVisible= true,
      this.tie = "修改"
      this.ArticleRevenue= row.ArticleRevenue	//文章收益
      this.VideoRevenue= row.VideoRevenue		//视频收益
      this.MusicRevenue= row.MusicRevenue		//音频收益
      this.PictureRevenue= row.PictureRevenue		//图片收益
      this.EditArticleRevenue= row.EditArticleRevenue		//编辑文章收益
      this.EffectTime = row.EffectTime	//生效时间
      this.Key = row.RevenueKey
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => { });
    },
    Income_allocation() {
      this.tie = "添加"
      this.dialogVisible = true;
    },
    handleCurrentChange(val) {
      this.formInline.PageIndex = val;
      this.loading();
    },
    onSubmit() {
      this.loading();
    },
    loading() {
      this.$Http_Post('management/materialIncomeData', { PageIndex: this.formInline.PageIndex, PageSize: this.formInline.PageSize, StartTime: this.formInline.time[0], EndTime: this.formInline.time[1], Name:this.formInline.Name }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.tableData = res.Data;
          this.UndoCount = res.Counts
        } else {
          this.Global.request_failure(res.Message);
        }
      })
    }
  },
}
</script>
<style>
.Workload_analysis{width: 100%;height: 100%;}
.Workload_analysis .demo-form-inline{padding: 20px;background-color: #fff;}

</style>
